import * as React from "react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { FilePicker } from "components/form";
import { FileUploadError, IImageDimensionsBoundary, loadFileAsDataURL, validateImageDimensions } from "utils/file";

interface IProps {
  onChange: (file: File) => void;
  onError: (error: FileUploadError) => void;
  extensions: string[];
  dimensions: IImageDimensionsBoundary;
  className?: string;
  maxSizeInMB?: number;
  children: React.ReactNode;
}

export class ImagePicker extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  private handleImageChange = async (file: any) => {
    const { onChange, onError, dimensions } = this.props;

    loadFileAsDataURL(file)
      .then(dataURL => validateImageDimensions(dataURL, dimensions))
      .then(isValid => {
        if (isValid) {
          onChange(file);
        }
      })
      .catch(error => onError(error));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, onChange, ...props } = this.props;

    return (
      <FilePicker onChange={this.handleImageChange} {...props}>
        {children}
      </FilePicker>
    );
  }
}
